import { AuthState, AuthType } from '../../../pollen/types';
import { type NostrKeychain } from '../types';
import { acceptShare, getVaultItems, putVaultItem, shareItem } from '..';

import { baseState } from './base';
import type { ItemKeys, StateFunc } from './types';

export function stateNostr(keychain: NostrKeychain, itemKeys: ItemKeys): StateFunc {
  return ({ userAPI, vaultAPI }) => ({
    ...baseState('nostr'),

    async putItem(item) {
      return putVaultItem(vaultAPI, itemKeys, keychain.auk, item);
    },

    async deleteItem(itemID) {
      await vaultAPI.deleteItem(itemID);
      delete itemKeys[itemID];
    },

    async items() {
      const [items, newItemKeys] = await getVaultItems(vaultAPI, keychain.auk, keychain.email);
      itemKeys = newItemKeys;
      return items;
    },

    async registerPasskey(nickname) {
      return userAPI.registerPasskey({ nickname }, keychain.auk);
    },

    authType() {
      return AuthType.Nostr;
    },

    async shareItem(itemID, extraParams, policy, localSsoFqdn) {
      return shareItem(vaultAPI, keychain.auk, itemID, itemKeys, extraParams, policy, localSsoFqdn);
    },

    async acceptShare(itemID: string, shareSecret: string, localSsoToken?: string) {
      const [items, newItemKeys] = await acceptShare(
        vaultAPI,
        keychain.auk,
        itemID,
        shareSecret,
        keychain.email,
        localSsoToken
      );
      itemKeys = newItemKeys;
      return items;
    },

    authState() {
      return AuthState.LoggedIn;
    },

    email() {
      return keychain.email;
    },
  });
}
